export class Unite {

    uni_id: string;
    uni_libelle: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.uni_id             = data['uni_id'] ? data['uni_id'] : null;
        this.uni_libelle        = data['uni_libelle'] ? data['uni_libelle'] : null;
    }

}
